import React from 'react';

import { Signature as StyledSignature } from './Signature.styles.js';

import SignatureCanvas from 'react-signature-canvas'

import './index.scss';
import { useWindowDimensions } from '../../utils/windowDimensionSize.js';
import Loading from '../../components/Loading/Loading.js';

function Signature({
	clear,
	save,
	undo,
	getCanvasRef,
	textCanvasRef,
	canvasOptions,
	signatureOptions,
	onChangeSignatureType,
	onChangeSignatureText,
	handleKeyDown,
	loading
}) {
	const { width } = useWindowDimensions();

	const isTextSignature = signatureOptions.signature_type === 'TEXT';

	return (
		<StyledSignature className='doca'>
			<StyledSignature.Container>
				<StyledSignature.Title>
					Assine abaixo para validar o documento
				</StyledSignature.Title>

				<StyledSignature.SignaturePad>
					<div hidden={!loading}>
						<Loading></Loading>
					</div>

					<div className="doca-button-group">
						<button hidden={loading} className={`text-button ${isTextSignature ? 'doca-button-group--active' : ''}`} onClick={() => onChangeSignatureType('TEXT')} >
							<i className="doca-icon doca-icon__text doca-icon--light doca-icon--large" />
						</button>
						<button hidden={loading} className={`canvas-button ${isTextSignature ? '' : 'doca-button-group--active'}`} onClick={() => onChangeSignatureType('CANVAS')} >
							<i className="doca-icon doca-icon__pen-field doca-icon--light doca-icon--large" />
						</button>
					</div>

					<div hidden={loading || signatureOptions.signature_type !== 'CANVAS'}>
						<SignatureCanvas
							ref={getCanvasRef}
							canvasProps={canvasOptions}
						/>
					</div>

					<div hidden={loading || signatureOptions.signature_type !== 'TEXT'}>
						<canvas hidden={true} width={canvasOptions.width} height={canvasOptions.height} ref={textCanvasRef}></canvas>
						<StyledSignature.SignaturePad.InputContainer>
							<StyledSignature.SignaturePad.TextArea value={signatureOptions.signature_text} maxLength={60} onChange={onChangeSignatureText} onKeyDown={handleKeyDown} placeholder='Digite aqui'/>
						</StyledSignature.SignaturePad.InputContainer>
					</div>

					<StyledSignature.Actions hidden={loading} className="doca doca-mt-2">
						<button className="doca-button doca-button--secondary doca-mr-2" onClick={clear}>
							<i className="doca-icon doca-icon__trash" />

							Limpar
						</button>

						{signatureOptions.signature_type === 'CANVAS' && (
							<button className="doca-button doca-button--secondary" onClick={undo}>
								<i className="doca-icon doca-icon__undo" />

								Desfazer
							</button>
						)}
					</StyledSignature.Actions>
				</StyledSignature.SignaturePad>

				{width >= 600 && (
					<StyledSignature.Footer>
						<button disabled={loading} className="doca-button doca-button--block doca-button--primary doca-mt-6" onClick={save}>
							Salvar assinatura
						</button>
					</StyledSignature.Footer>
				)}
			</StyledSignature.Container>

			{width < 600 && (
				<StyledSignature.FooterContainer>
					<StyledSignature.Footer>
						<button disabled={loading} className="doca-button doca-button--block doca-button--primary doca-mt-6" onClick={save}>
							Salvar assinatura
						</button>
					</StyledSignature.Footer>
				</StyledSignature.FooterContainer>
			)}
		</StyledSignature>
	);
}

export default Signature;
